import React, {useCallback, useEffect, useRef, useState} from 'react';
import {useDispatch} from 'react-redux';

import {CountrySuggest} from 'src/components/country-suggest';
import {useCountries} from 'src/hooks/dictionaries';
import {useEventTracking} from 'src/hooks/useEventTracking';

import {FlatButton} from '@pb/kit-component-button';
import {Dropdown} from '@pb/kit-component-dropdown';

import {applyUpdatedData, setCountry} from '../../../services/add-attendees-bulk.slice';


type Props = {
    selectedRecordIds: number[],
};

export const SetCountry = ({selectedRecordIds}: Props) => {
    const dispatch = useDispatch();
    const {countries} = useCountries();
    const {userFieldChange} = useEventTracking();
    const [dropdownShown, setDropdownShown] = useState(false);
    const closeTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const closeDropdown = useCallback(() => {
        if (closeTimeoutRef.current) {
            clearTimeout(closeTimeoutRef.current);
        }

        closeTimeoutRef.current = setTimeout(() => {
            setDropdownShown(false);
            closeTimeoutRef.current = null;
        });
    }, []);

    useEffect(() => () => {
        if (closeTimeoutRef.current) {
            clearTimeout(closeTimeoutRef.current);
        }
    }, []);

    const selectCountry = useCallback((countryCode: string) => {
        const country = countries.find(({code}) => code === countryCode);

        if (country) {
            dispatch(applyUpdatedData());
            dispatch(setCountry({ids: selectedRecordIds, country}));

            userFieldChange({
                section: 'Validate File',
                parameterName: 'Country',
                viewType: 'Bulk Import Users',
            });

            closeDropdown();
        }
    }, [selectedRecordIds, countries, dispatch, userFieldChange, closeDropdown]);

    return (
        <Dropdown
            shown={dropdownShown}
            setShown={setDropdownShown}
            anchor={({anchorRef, getAnchorProps}) => (
                <span
                    ref={node => {
                        if (typeof anchorRef === 'function') {
                            anchorRef(node);
                        }
                    }}
                    {...getAnchorProps()}>
                    <FlatButton disabled={false} onClick={() => undefined}>
                        <strong>
                            Set Country
                        </strong>
                    </FlatButton>
                </span>
            )}
            placement="top-start">
            <CountrySuggest onSelect={selectCountry} isAbsolute={true}/>
        </Dropdown>
    );
};
